$(function () {
    $('.js-press-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev">\n' +
                        '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="#fff" xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M13 23.1281L10.7365 25.8337L0 13.0003L10.7365 0.166992L13 2.87257L4.60572 13.0003L6.12777 14.9137L13 23.1281Z"/>\n' +
                        '</svg></span>\n' +
                    '</button>' ,
        nextArrow: '<button type="button" class="slick-next">\n' +
                        '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="#fff" xmlns="http://www.w3.org/2000/svg">\n' +
                            '<path d="M0 23.1281L2.26351 25.8337L13 13.0003L2.26351 0.166992L0 2.87257L8.39428 13.0003L6.87223 14.9137L0 23.1281Z"/>\n' +
                        '</svg></span>\n' +
                    '</button>' ,
        responsive: [
            {
                breakpoint: 821,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ]
    });

    $('.js-reviews-slider').slick({
        slidesToShow: 2.36,
        slidesToScroll: 1,
        centerMode: true,
        prevArrow: '<button type="button" class="slick-prev">\n' +
            '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M13 23.1281L10.7365 25.8337L0 13.0003L10.7365 0.166992L13 2.87257L4.60572 13.0003L6.12777 14.9137L13 23.1281Z"/>\n' +
            '</svg></span>\n' +
            '</button>' ,
        nextArrow: '<button type="button" class="slick-next">\n' +
            '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="#ffffff" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M0 23.1281L2.26351 25.8337L13 13.0003L2.26351 0.166992L0 2.87257L8.39428 13.0003L6.87223 14.9137L0 23.1281Z"/>\n' +
            '</svg></span>\n' +
            '</button>' ,
        responsive: [
            {
                breakpoint: 1180,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                },
            }, {
                breakpoint: 1080,
                settings: {
                    rows: 2,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                },
            },
        ]
    });

    $('.js-single-photos').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        fade: true,
        responsive: [
            {
                breakpoint: 821,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: true,
                    centerMode: true,
                },
            },
        ]
    });

    $('.js-testimonials-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev">\n' +
            '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M13 23.1281L10.7365 25.8337L0 13.0003L10.7365 0.166992L13 2.87257L4.60572 13.0003L6.12777 14.9137L13 23.1281Z" fill="#ffffff"/>\n' +
            '</svg></span>\n' +
            '</button>' ,
        nextArrow: '<button type="button" class="slick-next">\n' +
            '<span><svg width="13" height="26" viewBox="0 0 13 26" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M0 23.1281L2.26351 25.8337L13 13.0003L2.26351 0.166992L0 2.87257L8.39428 13.0003L6.87223 14.9137L0 23.1281Z" fill="#ffffff"/>\n' +
            '</svg></span>\n' +
            '</button>' ,
        responsive: [
            {
                breakpoint: 821,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                },
            },
        ]
    });

    //product details toggler
    $('.js-collection-details-button, .js-collection-details-label').on('click', function() {
        var $this = $(this);

        $this.parent('.js-collection-details').toggleClass('is-active')
    });
});